import React from 'react';

import { Box } from '@chakra-ui/react';
import { motion } from 'framer-motion';

import { useScrollProgress } from '@/hooks';
import colors from '@/theme/foundations/colors';
import { HEADER_HEIGHT } from '@/utils/constants';

type ReadProgressBarProps = {
  containerRef: HTMLDivElement | null;
};

export const ReadProgressBar = ({ containerRef }: ReadProgressBarProps) => {
  const scrollProgress = useScrollProgress(containerRef);

  return (
    <Box
      position="fixed"
      top={`calc(${HEADER_HEIGHT} - 1px)`}
      left={0}
      right={0}
      h="3px"
      backgroundColor="purple.100"
      zIndex="dropdown"
    >
      <motion.div
        style={{
          scaleX: scrollProgress,
          height: '100%',
          transformOrigin: '0%',
          backgroundColor: colors.violet[500],
        }}
      />
    </Box>
  );
};
